export default "__VITE_ASSET__BJwcqDJb__"